import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Regulamentos: React.FC = () => {

  const videos = [
    { video_id: '588944625', type_id: '2' },
    { video_id: '588944578', type_id: '2' },
    { video_id: '588944528', type_id: '2' }
  ];

  const gallery = [
    { url: 'mostra/1.png' },
    { url: 'mostra/2.png' },
    { url: 'mostra/3.png' },
    { url: 'mostra/4.png' },
    { url: 'mostra/5.png' },
    { url: 'mostra/6.png' },
    { url: 'mostra/7.png' },
    { url: 'mostra/8.png' },
    { url: 'mostra/9.png' },
    { url: 'mostra/10.png' },
    { url: 'mostra/11.png' },
    { url: 'mostra/12.png' },
    { url: 'mostra/13.png' },
    { url: 'mostra/14.png' },
  ]

  const kids = [
    { url: 'mostra/kids1.jpg' },
    { url: 'mostra/kids2.jpg' },
  ]

  return (
    <>


      <Container >
        <h2 style={{ width: '100%', margin: '40px 10px', textAlign: 'center', color: '#134842', fontSize: '28px' }}>REGULAMENTOS</h2>

        <a download href="/apoio/regulamento-para-inscricao-de-resumos-para-apresentacao-oral-xix-mostra-de-ensino-pesquisa-extensao-ufcspa.pdf">
          <button className='buttonBigGreen' style={{ height: 'auto', padding: '15px', marginTop: '0px' }}>
            REGULAMENTO PARA INSCRIÇÃO DE RESUMOS PARA APRESENTAÇÃO ORAL NA XI
            MOSTRA DE ENSINO, PESQUISA E EXTENSÃO DA UFCSPA

          </button>
        </a>

        <a download href="/apoio/regulamento-para-inscricao-de-resumos-para-apresentacao-de-eposter-3-congresso-ufcspa.pdf">
          <button className='buttonBigGreen' style={{ height: 'auto', padding: '15px', marginTop: '0px' }}>
            REGULAMENTO PARA INSCRIÇÃO DE RESUMOS PARA
            APRESENTAÇÃO DE E-PÔSTER NO 3º 36º Simpósio de Oftalmologia do HCPA: CIÊNCIA
            PARA UM MUNDO EM MOVIMENTO
          </button>

        </a>

        <a download href="/apoio/2-congresso-escolar-cientifica-da-ufcspa-regulamento.pdf">
          <button className='buttonBigGreen' style={{ height: 'auto', padding: '15px', marginTop: '0px' }}> REGULAMENTO PARA SUBMISSÃO DE TRABALHOS PARA O 2º CONGRESSO ESCOLAR CIENTÍFICO DA UFCSPA
          </button>
        </a>
      </Container>
    </>
  );
};
export default Regulamentos;
